import {SimCardInterface} from "../../dataInterface/simCardInterface";
import {subScriptionTypeDataInterface} from "../../dataInterface/subScriptionTypeDataInterface";
import {SubscriptionDataInterface} from "../../dataInterface/subscriptionDataInterface";


interface subLogs {
    type:string
    payload:SubscriptionDataInterface
}

export default (state = null, action:subLogs) => {
    switch (action.type) {
        case "DEVICE_SUBSCRIPTION_LOGS":
            return action.payload;
        default:
            return state;
    }
};
